<template>
    <van-popup class="share-select-same-popup" 
        v-bind:value="showPop" 
        v-bind:close-on-click-overlay="overlayClickClose" 
        v-bind:close-on-popstate="true"
        @click-overlay='clickOverlay'>

        <div class="share-sspp-title">{{setting[shareType].title1}}<br>{{setting[shareType].title2}}</div>
        <div class="share-sspp-list">
            <div class="share-sspp-item" v-for="data in selectedList" @click="clickSelectedFate(data)" v-bind:key="'share-sspp-item' + data.f_name + Math.random(0, 10)">
                {{setting[shareType].label1}}：{{data.f_name.slice(0, 8)}}({{data.sex == 0 ? '男' : '女'}})
                <i class="iconfont icon-arrow-you share-sspp-icon"></i>
            </div>
        </div>
        <div class="share-cgpp-button" @click="saveToNew">{{setting[shareType].saveText}}</div>
    </van-popup>
</template>

<script>
export default {
    name: 'VantShareSelectPop',
    props: [
        'shareType', 
        'showPop',
        'selectedList',
        'selectItemFunc',
        'overlayClickClose',
        'overlayFunc',
        'saveToNewFunc'
    ],
    data() {
        return {
            setting: {
                '3': {
                    title1: '已存在四柱相同但不同名的八字',
                    title2: '请选择要保存到的目标：',
                    label1: '保存到',
                    saveText: '保存到新八字下面'
                },
                '6': {
                    title1: '已存在四柱相同但不同名的八字',
                    title2: '请选择要保存到的目标：',
                    label1: '保存到',
                    saveText: '保存到新八字下面'
                }
            },
            newLock: false
        }
    },
    methods: {
        clickOverlay() {
            if(this.overlayFunc && typeof(this.overlayFunc) == 'function') {
                this.overlayFunc();
            }
        },
        clickSelectedFate(data){
            if(this.selectItemFunc && typeof(this.selectItemFunc) == 'function') {
                this.selectItemFunc(data);
            }
        },
        saveToNew() {
            if(this.newLock) {
                return;
            }

            // 防止重复点击
            this.newLock = true;
            var me = this;
            setTimeout(() => {
                me.newLock = false;
            }, 500);

            if(this.saveToNewFunc && typeof(this.saveToNewFunc) == 'function') {
                this.saveToNewFunc();
            }
        }
    }
}
</script>